<template>
  <div class="home-page">
    <a-layout class="home-page">
      <a-layout-header>
        <div class="navbar-page">
          <div class="logo-page global-btn" @click="home">51Card</div>
          <a-dropdown @select="handleSelect">
            <button class="login-page global-btn glowing-box">
              设置
              <icon-down/>
            </button>
            <template #content>
              <a-doption :value="1">订阅服务</a-doption>
              <a-doption :value="2">退出</a-doption>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>
      <a-layout class="content">
        <a-layout-sider :width="230">
          <div class="sider">
            <a-menu mode="pop" v-model:selected-keys="selectedKeys" @menu-item-click="itemClick">
              <div v-for="(item,index) in menuList" :key="index">
                <div v-if="!item.path">{{ item.title }}</div>
                <div v-else class="main-item">
                  <a-menu-item :key="item.key">
                    <template #icon>
                      <a-image :preview="false" :src="item.icon" :height="item.height"/>
                    </template>
                    {{ item.title }}
                  </a-menu-item>
                </div>
              </div>
            </a-menu>
          </div>
        </a-layout-sider>
        <a-layout-content>
          <transition mode="out-in">
            <router-view/>
          </transition>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import menuList from './menu'
import {IconDown} from "@arco-design/web-vue/es/icon";

export default {
  name: 'Home',
  components: {IconDown},
  data() {
    return {
      menuList,
      selectedKeys: ['card'],
      link: '',
      userInfo: ''
    }
  },
  watch: {
    '$route.name': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (this.$route.name === 'dashboard') {
            this.$router.push({
              name: 'card'
            })
          }
          if (this.$route.name === 'card') {
            this.selectedKeys[0] = 'card'
          } else {
            this.link = this.$route.name
            this.selectedKeys[0] = this.link
          }
        })
      }
    },
    '$store.getters.token': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (!newVal) {
            this.userInfo = {}
            this.$router.push('/')
          }
        })
      }
    },
  },
  created() {
    // 用户信息
    let user = localStorage.getItem('USER_INFO')
    if (user) {
      this.userInfo = JSON.parse(user)
    } else {
      this.$router.push('/')
    }
    if (this.$route.name === 'dashboard') {
      this.link = 'card'
      this.selectedKeys[0] = this.link
      this.$router.push({name: 'card'})
    } else {
      this.link = this.$route.name
      this.selectedKeys[0] = this.link
      this.$router.push({
        name: this.$route.name,
        query: {}
      })
    }
  },
  methods: {
    handleSelect(e) {
      if(e === 1){
        this.toDashBoard()
      }
      if(e === 2){
        this.logout()
      }
    },
    logout(){
      this.$store.dispatch('GETLOGOUT')
    },
    toDashBoard() {
      this.$router.push({path: "/card"});
    },
    itemClick(e) {

      if (e === 'card') {
        this.$router.push({name: 'card'})
      }
      if (e === 'service') {
        this.$router.push({name: 'service'})
      }
      if (e === 'privacyPolicy') {
        this.$router.push({name: 'privacyPolicy'})
      }
    },
    home() {
      this.$router.push({path: "/"});
    },
  },
}
</script>

<style>
.arco-menu-vertical .arco-menu-inner {
  padding: 0 !important;
}

.arco-layout-sider-children {
  background: #e0f4ff !important;
  box-shadow: none !important;
}

.arco-layout-sider-light {
  box-shadow: none !important;
}

.content {
  padding: 0 200px !important;
}

.arco-menu-light {
  background-color: #e0f4ff !important;
}

.arco-menu-light .arco-menu-item {
  background-color: #e0f4ff !important;
}

.arco-menu-vertical .arco-menu-item {
  padding: 0 !important;
}

.arco-menu-light .arco-menu-item.arco-menu-selected {
  background-color: #BDE7FF !important;
  color: #333333 !important;
  padding-left: 10px !important;
  width: 220px !important;
  border-radius: 10px !important;
}

.sider {
  background: inherit !important;
  padding: 60px 10px;
  font-size: 14px;
  color: gray;
  text-align: left;
}

.main-item {
  margin: 20px 0 !important;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  display: flex;
}

.home-page {
  background: #e0f4ff;
  overflow-x: hidden;
  height: 100vh;
}

.logo-page {
  font-size: 32px;
  margin-left: 20px;
}

.login-page {
  height: 42px;
  margin-right: 40px;
  padding-right: 20px;
  padding-left: 20px;
  border-radius: 25px;
  border: 1px solid #d8e8f7;
  font-size: 20px;
  background: #333333;
  color: #ffffff;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.8); /* 白色发光 */
}

.navbar-page {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  height: 64px;
  align-items: center;
  background: #ffffff;
}
</style>
